import type { UserInfo } from '@vben/types';

import { requestClient } from '#/api/request';

/**
 * 获取用户信息
 */
export async function getUserInfoApi() {
  return requestClient.get<UserInfo>('/user/info');
}

// 获取用户详细信息
export async function getInfoApi() {
  return requestClient.get<UserInfo>('/merchant/info');
}

// 获取分销商用户详细信息
export async function getDistributorInfoApi() {
  return requestClient.get<UserInfo>('/distributor/info');
}

// 获取用户详细信息
export async function updateInfoApi(data: UserInfo) {
  return requestClient.post('/merchant/update-merchant-info', data);
}

// 获取用户详细信息
export async function updateInfoPasswordApi(data: Record<string, any>) {
  return requestClient.post('/merchant/update-merchant-info-password', data);
}
// 获取用户详细信息
export async function updatePasswordApi(data: UserInfo) {
  return requestClient.post('/merchant/update-password', data);
}
// 获取短信验证码
export async function getSMSCodeApi(phone: number | string) {
  return requestClient.get('/merchant/get-sms-code/', {
    params: { phone },
    headers: {
      isToken: false,
    },
  });
}

export async function getStatisticsSummaryApi(data: Record<string, any>) {
  return requestClient.post('/merchant/statistics/summary', data);
}

export async function getStatisticsDetailListApi(data: Record<string, any>) {
  return requestClient.post('/merchant/statistics/detail-list', data);
}

// 获取短信验证码
export async function getNoticeApi() {
  return requestClient.get('/merchant/notice');
}

// 商户/店铺/同意
export async function agreeTkProtocolApi() {
  return requestClient.post('/merchant/shop/agree', {});
}
